import React, {useEffect, useState} from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {makeStyles} from '@material-ui/core/styles';
import {useTranslation} from "react-i18next";
import GroupGeneralInfo from "./ProGroupEditorTabs/GroupGeneralInfo";
import GroupProviders from "./ProGroupEditorTabs/GroupProviders";
import {getGroup, upsertGroup} from "../../../../api/pro-guest-functions";
import {useApiNotification} from "../../../ui/ApiNotificationProvider";
import GroupGuests from "./ProGroupEditorTabs/GroupGuests";
import {run} from "../../../../utils/function-util";
import {Group, UpsertGroupRequest} from "../../../../models/pro-guest.models";
import {TabPanel} from "../../../_shared/TabPanel";

const useStyles = makeStyles((theme) => ({
    root: {
        margin: theme.spacing(2),
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    tabsPanel: {
        margin: theme.spacing(2)
    }
}));
export const ProGroupEditor = ({organizationId, folderId, groupId, onGroupNameChange, onClose}: any) => {
    const classes = useStyles();
    const [group, setGroup] = useState({name: ''});
    const {t} = useTranslation();
    const [currentTab, setCurrentTab] = useState(0);
    const {handleError} = useApiNotification();
    useEffect(run(getGroup({
        organizationId,
        folderId,
        groupId
    }), (g: Group) => {
        setGroup(g);
        onGroupNameChange(g.name);
    }, handleError), [folderId, groupId]);
    const handleTabChange = (event: any, newValue: any) => {
        setCurrentTab(newValue);
    };
    const handleNameChange = async (name: string) => {
        await upsertGroup({organizationId, folderId, group: {...group, name}} as UpsertGroupRequest)
            .then((newGroup) => {
                setGroup(newGroup);
                onGroupNameChange(name);
            })
            .catch(handleError);
    };
    return <div className={classes.root}>
        <Tabs value={currentTab} onChange={handleTabChange} aria-label="pro-guest tabs" indicatorColor="primary" variant="scrollable">
            <Tab label={t('ProGuest.Groups.Tabs.General.Title')} {...buildTabId(0)}/>
            <Tab label={t('ProGuest.Groups.Tabs.Providers.Title')} {...buildTabId(1)}/>
            <Tab label={t('ProGuest.Groups.Tabs.Guests.Title')} {...buildTabId(2)}/>
        </Tabs>

        <TabPanel className={classes.tabsPanel} value={currentTab} index={0} preserveTab={false}>
            <GroupGeneralInfo group={group} onNameChange={handleNameChange} onClose={onClose}/>
        </TabPanel>
        <TabPanel className={classes.tabsPanel} value={currentTab} index={1} preserveTab={false}>
            <GroupProviders organizationId={organizationId} folderId={folderId} groupId={(group as any).id}
                            onClose={onClose}/>
        </TabPanel>
        <TabPanel className={classes.tabsPanel} value={currentTab} index={2} preserveTab={false}>
            <GroupGuests organizationId={organizationId} folderId={folderId} groupId={(group as any).id}
                         onClose={onClose}/>
        </TabPanel>
    </div>;
};

function buildTabId(index: any) {
    return {
        id: `tab-${index}`,
        'aria-controls': `tabpanel-${index}`,
    };
}
